"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AreYouSureModal_1 = require("./AreYouSureModal");
exports.default = AreYouSureModal_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/AreYouSureModal/index.js
// module id = 589
// module chunks = 8